import {Actions as FenceActions} from "../../../stores/reducers/fences-reducers";

export const toggleFenceEditModeActions = {
    mount: () => FenceActions.SET_EDIT_MODE(true),
    unmount: () => FenceActions.SET_EDIT_MODE(false),
};